module.exports = {
  buttons: {
    backLink: "WSTECZ",
    cancelButton: "ANULUJ",
    chatWithAgentButton: "OTWÓRZ CZAT Z AGENTEM",
    closeButton: "ZAMKNIJ",
    contactSupportButton: '<a href="" class="adsktm-show-contact-support-btn">SKONTAKTUJ SIĘ Z POMOCĄ TECHNICZNĄ</a>',
    copiedButton: "SKOPIOWANE",
    copyButton: "KOPIUJ",
    getStartedButton: "ROZPOCZNIJ",
    haveAQuestion: "Masz pytanie?",
    helpPanel: '<a target="_blank" href="https://knowledge.autodesk.com/pl/contact-support/installation-activation/activation-registration">MASZ PYTANIE?</a>',
    nextButton: "DALEJ",
    requiredLabel: "Wymagane",
    restartButton: "ZACZNIJ OD NOWA",
    signInButton: "ZALOGUJ SIĘ",
    submitAgainButton: "PRZEŚLIJ PONOWNIE",
    submitButton: "PRZEŚLIJ",
    tryAgainButton: "SPRÓBUJ PONOWNIE",
    notNow: "NIE TERAZ",
    validate: `ZWERYFIKUJ`
  },
  signIn: {
    gatheringInfo: "Zbieranie informacji o koncie",
    helloUser: "Witaj, <first-name>!",
    justAMoment: "Chwileczkę...",
    signInNow: "<a>Zaloguj się teraz</a>",
    signInHelp: `<a target="_blank" href="https://knowledge.autodesk.com/pl/contact-support/account-management/account-creation-sign-profile-management">Masz problemy z zalogowaniem?</a>`,
    startAccessAccount: "Zacznijmy od uzyskania dostępu do Twojego konta."
  },
  contactOptions: {
    addtlComments: "Dodatkowe uwagi (opcjonalne)",
    addtlCommentsMsg: "Zostanie utworzone zgłoszenie z informacjami podanymi powyżej. W tym polu podaj wszelkie inne rzeczy, które powinniśmy wiedzieć.",
    addtlCommentsReqd: `Opis`,
    agentAvailable: "Agent dostępny",
    agentAvailableStdby: "Agent jest dostępny — zaczekaj",
    agentUnavailable: "Agent niedostępny",
    cancelCase: "ANULUJ ZGŁOSZENIE",
    cancelChat: "ANULUJ CZAT",
    caseConfirm1: "Wkrótce otrzymasz wiadomość e-mail z potwierdzeniem. Jeśli wiadomość nie dotrze, sprawdź folder ze spamem.",
    caseConfirm2: "Jeden z naszych agentów zapozna się ze zgłoszeniem i skontaktuje się z Tobą w ciągu 2 dni roboczych.",
    caseDetails: "Szczegóły zgłoszenia",
    caseNumber: "Numer zgłoszenia: <case-number>",
    caseSubmitted: "Zgłoszenie przesłane",
    chatWithAgent: "Otwórz czat z agentem",
    closingWindowMsg: "zamknięcie tego okna przed nawiązaniem połączenia może spowodować anulowanie czatu",
    connectMomentarily: "Za kilka chwil nawiążemy połączenie.",
    createCase: "Utwórz zgłoszenie",
    errorLabel: "Błąd",
    forceStartChat: "<a>Kliknij tutaj, aby rozpocząć czat.</a>",
    getCaseAnswer2Days: "Uzyskaj odpowiedź w ciągu 2 dni",
    mayCloseWindow: "Teraz możesz zamknąć to okno.",
    note: "UWAGA:",
    orSubmitCase: "Możesz też <a>przesłać zgłoszenie<a/>, a ktoś się z Tobą skontaktuje w ciągu 2 dni roboczych.",
    popUpBlocker: "Masz włączone blokowanie wyskakujących okienek? ",
    productLabel: "Produkt",
    sorryNoAgent: "Niestety, w tej chwili żaden agent nie jest dostępny",
    willUpdateAgent: "Zaktualizujemy ten ekran, gdy tylko jeden z agentów będzie dostępny.",
    yourContactInfo: "Twoje dane kontaktowe"
  },
  welcome: {
    important: "Ważne:",
    noteForTheUser: "Uwaga:"
  },
  captchaScreen: {
    correctMsg: "Prawidłowe!",
    incorrectMsg: "Nieprawidłowe. Spr&oacute;buj ponownie.",
    pageTitle: "Kontrola bezpieczeństwa",
    typeCaptchaLabel: "Wprowadź znaki, kt&oacute;re widzisz powyżej"
  },
  contactInfoScreen: {
    pageTitle: "1. Twoje dane kontaktowe",
    nameLabel: "Imię i nazwisko",
    firstNamePlaceholder: "Imię",
    lastNamePlaceholder: "Nazwisko",
    emailTitle: "E-mail",
    emailDisclaimer: "Potrzebujemy tych informacji, aby wysłać potwierdzenie."
  },
  reviewAccountInfo: {
    pageTitle: "1. Sprawdź swoje informacje o koncie",
    helloUser: "Witaj, <first-name>!",
    signedInAs: "Użytkownik jest zalogowany jako:",
    emailConfirm: "Na podstawie tego adresu e-mail odszukamy Twoje konto i wyślemy potwierdzenie.",
    differentAccount: "<a>Zaloguj się na inne konto</a>"
  },
  processInfoScreen: {
    checkSerialMsg: "Aby sprawdzić ten numer seryjny, naciśnij klawisz Enter.",
    continueTyping: "Wpisz numer seryjny w formacie XXX-XXXXXXXX.",
    doNotNeedHula: "<strong>Mamy dobre wiadomości!</strong> Nie musisz zamawiać osobnej licencji do użytku domowego. Oprogramowanie możesz zainstalować i aktywować na komputerze domowym, podając ten sam numer seryjny.",
    downloadYourProduct: `Pobierz produkt i zainstaluj go. Dodatkowa aktywacja nie będzie konieczna.`,
    emailForSerialNumPlaceholder: "Powiązany adres e-mail",
    emailForSerialNumTitle: "Adres e-mail powiązany z numerem seryjnym",
    emailForSerialNumTooltip: "Adres e-mail koordynatora ds. oprogramowania, kierownika ds. umów lub osoby, która kupowała oprogramowanie",
    ineligiblePerpetual: 'Ten numer seryjny jest powiązany z licencją wieczystą, która <b>nie uprawnia</b> do użytku domowego.<br/><br/>Z subskrypcji naszego oprogramowania można korzystać zawsze i wszędzie. <a target="_blank" href="https://www.autodesk.pl/subscription">Dowiedz się więcej o zaletach subskrypcji</a>.',
    justTypeIn: "- Jeśli Twój numer seryjny nie jest tu wymieniony, spróbuj go wpisać. -",
    msgEducationSerialNum: "Ten numer seryjny dotyczy licencji edukacyjnej.",
    msgGoToEducationComm: '<a target="_blank" href="https://www.autodesk.com/education/free-software/all">Przejdź do witryny Education Community</a>',
    msgIndustryCollectionSerialNum: "Ten numer seryjny jest częścią kolekcji: <collection-name>",
    msgNetworkSerialNum: `To jest numer seryjny <Strong>licencji sieciowej</Strong> i kod aktywacyjny nie jest potrzebny. Skontaktuj się z administratorem sieci, aby sprawdzić, czy licencja została poprawnie skonfigurowana.`,
    msgSubscriptionSoftware: `To jest numer seryjny <Strong>oprogramowania subskrypcyjnego</Strong> i kod aktywacyjny nie jest potrzebny. Uruchom produkt, gdy komputer będzie podłączony do Internetu. Następnie po prostu <a target="_blank" href="https://knowledge.autodesk.com/article/subscriber-activation">zaloguj się</a> lub <a target="_blank" href="https://knowledge.autodesk.com/article/online-activation-registration">wprowadź numer seryjny</a>.`,
    msgBiCIndirectSoftware: "You no longer need an activation code because your license is now part of our improved account experience. Just sign in using your Autodesk email and password to start using the software (make sure you are connected to the internet).",
    msgBicIndirectSCRole: 'The software coordinator role is not included with your license. See <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/user-management/primary-admins">Primary and Secondary admins</a> for information about the admin roles included with your license.',
    msgSN2010orOlder: 'The serial number you entered is for an older version that is no longer supported. <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">See eligibility requirements</a>',
    myProductNotListed: "Mojego produktu nie ma na liście",
    noResultsMsg: "Nie znaleziono wyników. Wprowadź numer seryjny w formacie XXX-XXXXXXXX.",
    pageTitle: "2. Informacje o produkcie",
    partOfCollection: "Produkt jest częścią kolekcji: <collection-name>",
    requestCodeTitle: "Kod żądania",
    requestCodetooltip: 'Jak znaleźć <a target="_blank" href="https://www.autodesk.com/find-request-code-pol">kod żądania</a>',
    selectPlaceholder: "Wybierz",
    selectProduct: "Wybierz konkretny produkt",
    selectProductPlaceholder: "Wybierz produkt",
    selectYourProductTitle: "Wybierz produkt",
    serialNumberLabel: "Numer seryjny",
    serialNumberPlaceholder: "Szukaj według nazwy - lub - wpisz numer",
    serialNumbersInAccount: "NUMERY SERYJNE NA TWOIM KONCIE",
    serialNumberTooltip: 'Jak znaleźć <a target="_blank" href="https://www.autodesk.com/find-serial-number-pol">numer seryjny</a>',
    yesOption: `Tak`,
    noOption: `Nie`,
    currentInfoTitle: `Obecne informacje`,
    contractNumDisclaimer: `Dodaj łącznik (-), jeśli znajduje się on w Twoim numerze kontaktowym.`,
    contractNumLabel: `Numer umowy`,
    contractNumTooltip: `Numer umowy znajdziesz w obszarze Rozliczenia i zamówienia na swoim <a target="_blank" href="https://manage.autodesk.com">koncie</a>.`
  },
  authorizationRequestScreen: {
    enterEmail: "Wprowadź adres e-mail",
    option1: "Oświadczam, że jestem administratorem, kierownikiem ds. umów lub koordynatorem ds. oprogramowania dla tego produktu.",
    option2: "Oświadczam, że przesyłam to zamówienie w imieniu administratora, kierownika ds. umów lub koordynatora ds. oprogramowania, którego adres e-mail to:",
    pageTitle: "3. Upoważnienie do przesłania zamówienia",
    selectOne: "Wybierz jedną z opcji"
  },
  processingScreen: {
    firstMsg: "Trwa przetwarzanie żądania",
    takingLongerExpected: "To jeszcze chwilę potrwa. Prosimy o cierpliwość.",
    updatedMsgLonger: "Nadal pracujemy",
    willTakeSecs: "Może to potrwać kilka sekund..."
  },
  successScreen: {
    expirationLine: "<br/>Data ważności: <expiration-date>",
    infoWillBeEmailed: "Informacje te wyślemy również na adres e-mail: <email>",
    pageTitle: "Powodzenie",
    prodSeatMulti: "<product-name> (na <number-seats> stanowisk)<br/>",
    prodSeatSingle: "<product-name> (na 1 stanowisko)<br/>",
    pvApprovedMsg: "Twój wniosek o poprzednią wersję został zatwierdzony.",
    pvInstruction: "Zainstaluj i aktywuj oprogramowanie, podając następujące informacje.",
    reponseText: "Twój kod aktywacji: <activation-code>",
    responseText1: "Zatwierdzono zamówienie licencji do użytku domowego.",
    responseText2: "Zainstaluj i aktywuj oprogramowanie, podając następujące informacje. Podczas instalacji wybierz opcję „pojedyncza”.",
    responseText3: "Numer seryjny: <serial-number><br/>Klucz produktu: <product-key>",
    updateDisclaimer: `Zmiana może być widoczna na koncie dopiero za kilka godzin.`
  },
  errors: {
    emailNotAssocWithSerialNumber: "Ten adres e-mail nie jest powiązany z danym numer seryjnym. ",
    enterCMSCEmail: "Wprowadź adres e-mail kierownika ds. umów lub koordynatora ds. oprogramowania dla tego produktu",
    enterComments: "Wprowadź opis",
    enterEmail: "Wprowadź adres e-mail",
    enterEmailAssociated: "Wprowadź powiązany adres e-mail",
    enterFirstName: "Wprowadź imię",
    enterLastName: "Wprowadź nazwisko",
    enterRequestCode: "Wprowadź kod żądania",
    enterSerialNumber: "Wprowadź numer seryjny",
    enterValidFormat: "Wprowadź dane w poprawnym formacie",
    invalidAutodeskSerialNumber: '<p>To nie jest poprawny numer seryjny Autodesk.</p><p>Upewnij się, że używasz oprogramowania pochodzącego z autoryzowanego źródła:</p><ul><li><a target="_blank" href="http://www.autodesk.com/store">Sklep Autodesk</a></li><li><a target="_blank" href="https://www.autodesk.pl/resellers/locate-a-reseller">Autoryzowani sprzedawcy</a></li><li><a target="_blank" href="https://www.autodesk.com/education/prepare-and-excel/authorized-academic-partner">Partnerzy edukacyjni</a></li></ul>',
    invalidLicenseModel: "Produkt ma nieprawidłowy model licencji.",
    invalidRequestcode: "Nieprawidłowy kod żądania",
    invalidSerialNumber: "Nieprawidłowy numer seryjny",
    notCMSC: "Z naszych danych wynika, że nie jesteś kierownikiem ds. umów ani koordynatorem ds. oprogramowania dla tego produktu.",
    oops: 'Niestety, podczas przetwarzania żądania wystąpił problem. <a target="_blank" href="https://knowledge.autodesk.com/pl/contact-support/installation-activation/activation-registration">Skontaktuj się z pomocą techniczną</a>',
    overActivation: "Nadmierna liczba aktywacji",
    productExpired: "Ważność produktu, który usiłujesz aktywować, wygasła.",
    reasonForActivation: "Przyczyna aktywacji",
    serialNumNotAssocWithSingleLicense: "Ten numer seryjny nie jest powiązany z licencją dla jednego użytkownika.",
    serialNumNotFound: "Nie znaleziono numeru seryjnego",
    serialNumNotRegisteered: 'Ten numer seryjny nie został jeszcze zarejestrowany. Najpierw go <a target="_blank" href="http://registeronce.autodesk.com/">zarejestruj</a>.'
  },
  requestFailedScreen: {
    caseError: "Niestety, podczas wysyłania zgłoszenia wystąpił problem.",
    contactOptionsBelow: `Jeśli potrzebujesz pomocy, skorzystaj z jednej z poniższych opcji <a id="go-to-contact-us" href="javascript:void(0);">kontaktu z nami</a>.`,
    expiredSubsTitle: `Subskrypcja wygasła`,
    expiredSubscription: `Nie możemy przetworzyć zgłoszenia, ponieważ Twoja subskrypcja wygasła. Skontaktuj się z administratorem konta lub zaloguj się na swoje <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">konto</a>, aby poznać dostępne opcje odnowienia.`,
    inactiveSubsTitle: "Nieaktywna subskrypcja",
    noActiveSubs: `Nie można zrealizować żądania, ponieważ Twoja subskrypcja wygasła lub nie jest jeszcze aktywna. Skontaktuj się z administratorem konta lub zaloguj się na swoje <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">konto</a>, aby poznać dostępne opcje odnowienia.`,
    pageTitle2: "Nie można zrealizować żądania",
    pageTitle: "Przetworzenie żądania nie powiodło się",
    prodNotEligibleTitle: "Produkt nie kwalifikuje się",
    prodNotRegisteredTitle: `Produkt nie jest zarejestrowany`,
    prodNotRegistered: `Nie możemy przetworzyć zgłoszenia, ponieważ produkt nie został jeszcze zarejestrowany.<br><br><a target="_blank" href="https://registeronce.autodesk.com">Zarejestruj produkt</a>`,
    responseText: "Niestety, podczas przetwarzania żądania wystąpił problem."
  },
  gac: {
    welcome: {
      clickGetStarted: "Aby uzyskać kod aktywacyjny, kliknij przycisk Rozpocznij.",
      modalTitle: "Pobieranie kodu aktywacji",
      noteBullet1: `Kod aktywacyjny jest potrzebny tylko wtedy, kiedy masz pojedynczą licencję wieczystą lub pojedynczą licencję edukacyjną (dla student&oacute;w lub wykładowc&oacute;w) i <strong>nie masz dostępu do Internetu.</strong>`,
      noteBullet2: `<strong>Jeśli masz dostęp do Internetu, nie potrzebujesz kodu aktywacyjnego.</strong> Wystarczy, że uruchomisz sw&oacute;j produkt i wykonasz instrukcje dotyczące <a target="_blank" href="https://www.autodesk.com/sign-in-activation-pol">logowania</a> lub <a target="_blank" href="https://www.autodesk.com/access-with-serial-number-pol">wprowadzania numeru seryjnego.</a>`
    },
    signInOptional: {
      title: "Logowanie (opcjonalne)",
      message: `Będzie łatwiej, jeśli się zalogujesz, ale nie musisz tego robić.`
    },
    overActScreen: {
      actAgainLabel: "Wybierz przyczynę ponownej aktywacji",
      pageTitle: "3. Przyczyna ponownej aktywacji",
      reason1: "Nowy komputer",
      reason2: "Kradzież komputera",
      reason3: "Ponowna instalacja oprogramowania",
      reason4: "Inny powód",
      responseText: "Ten numer seryjny już aktywowano.",
      selectReason: "Wybierz przyczynę"
    }
  },
  hula: {
    welcome: {
      clickGetStarted: "Kliknij przycisk Rozpocznij, aby otrzymać numer seryjny na użytek domowy.",
      intro: "Wykonaj podane kroki, aby szybko uzyskać licencję do użytku domowego.",
      modalTitle: "Zamów licencję do użytku domowego",
      noteBullet1: 'Licencje do użytku domowego są dostępne do <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-pol">kwalifikujących się produktów</a> z subskrypcją dla wielu użytkowników lub licencją sieciową z planem obsługi.',
      noteBullet2: "Subskrypcje dla pojedynczego użytkownika automatycznie uwzględniają użytek domowy. Oprogramowanie możesz zainstalować i aktywować na komputerze domowym, podając ten sam numer seryjny."
    },
    processInfoScreen: {
      hulaEligibleVersionMsg: 'Powyżej wymieniono tylko kwalifikujące się wersje. <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-pol">Zobacz wymagania kwalifikacji</a>',
      crossGradeHulaMessage: `Tutaj nie możemy przetworzyć Twojego żądania. Aby uzyskać licencję na użytek domowy na wybraną wersję, należy <a id="go-to-create-case" href="javascript:void(0);">utworzyć zgłoszenie.</a> Skontaktujemy się z Tobą w ciągu 2 dni roboczych.`
    },
    errors: {
      tokenFlexSerialNumber: `You’ve entered a TokenFlex serial number. To request a home use license, please email your Autodesk Premier Expert at <strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>.`
    },
    requestFailedScreen: {
      hulaEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-pol">Zobacz wymagania kwalifikacji</a>',
      hulaIneligible: `Nie możemy przetworzyć zgłoszenia, ponieważ ten produkt nie kwalifikuje się do uzyskania licencji do użytku domowego.`
    }
  },
  pv: {
    welcome: {
      clickGetStarted: "Kliknij przycisk Rozpocznij, aby uzyskać dostęp do poprzedniej wersji oprogramowania.",
      intro: "Wykonaj następujące czynności, aby szybko uzyskać dostęp do poprzedniej wersji oprogramowania.",
      modalTitle: "Złóż wniosek o dostęp do poprzedniej wersji",
      noteBullet1: 'Jeśli masz subskrypcję, po prostu zaloguj się na swoje <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">konto</a> i pobierz poprzednią wersję, której potrzebujesz.',
      noteBullet2: 'Jeśli masz licencję pojedynczą z planem obsługi, użyj opisanej metody, aby zamówić dostęp do poprzednich wersji <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-pol">kwalifikujących się</a> produktów.'
    },
    processInfoScreen: {
      noPvAvailable: 'Poprzednie wersje produktu, o który wnioskowano, są niedostępne. Aby uzyskać dodatkowe informacje, zapoznaj się z naszymi <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-pol">zasadami dotyczącymi poprzednich wersji</a>.',
      pvEduUserMsg: 'Masz licencję edukacyjną. Odwiedź stronę <a target="_blank" href="https://www.autodesk.com/education/free-software/all">Autodesk Education Community</a>, gdzie możesz pobrać nawet trzy poprzednie wersje.',
      pvEligibleVersionMsg: 'Powyżej wymieniono tylko kwalifikujące się wersje. <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">Zobacz wymagania kwalifikacji</a>',
      pvMultiUserSubsMsg: `Masz subskrypcję dla wielu użytkownik&oacute;w. Numery seryjne poprzednich wersji są wyświetlane na Twoim <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">koncie</a>.`,
      pvNetworkMaintenanceUserMsg: `Masz licencję sieciową. Numery seryjne poprzednich wersji są wyświetlane na Twoim <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">koncie</a>.`,
      pvPerpetualUserMsg: 'Warunki licencji wieczystej tego produktu nie obejmują dostępu do poprzednich wersji.<br/><br/>Dostęp do poprzednich wersji przysługuje w przypadku subskrypcji. <a target="_blank" href="https://www.autodesk.pl/subscription">Dowiedz się więcej o zaletach subskrypcji</a></a>',
      pvSingleUserSubsMsg: 'Masz subskrypcję dla jednego użytkownika. Aby uzyskać dostęp do maksymalnie trzech poprzednich wersji, po prostu wskaż potrzebne produkty na swoim <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">koncie.</a> W tym celu znajdź odpowiedni link o treści „Pobierz numer seryjny”.',
      serialNumberCurrentLabel: "Bieżący numer seryjny",
      versionRequestingLabel: "Wnioskowana wersja"
    },
    errors: {
      tokenFlexSerialNumber: `You’ve entered a TokenFlex serial number. To request a previous version license, please email your Autodesk Premier Expert at <strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>.`
    },
    requestFailedScreen: {
      pvEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-pol">Zobacz wymagania kwalifikacji</a>',
      pvInactiveSubscription: 'Nie możemy przetworzyć wniosku, ponieważ subskrypcja tego produktu nie jest już aktywna na Twoim <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">koncie.</a>',
      pvIneligible: "Nie możemy przetworzyć zgłoszenia, ponieważ ten produkt nie kwalifikuje do uzyskania licencji na poprzednią wersję."
    }
  },
  cm: {
    welcome: {
      clickGetStarted: "Kliknij przycisk Rozpocznij, aby zmienić kierownika ds. umów.",
      modalTitle: "Zmień kierownika ds. umów",
      noteBullet1: "Zmiana kierownika ds. umów jest możliwa w przypadku planów obsługi i subskrypcji bez automatycznego odnawiania.",
      noteBullet2: "Jeśli masz subskrypcję z automatycznym odnawianiem, zmiana kierownika ds. umów wymaga anulowania tej subskrypcji i rozpoczęcia nowej."
    },
    processInfoScreen: {
      cmEmailPlaceholder: "Powiązany z numerem umowy",
      contractNumDisclaimer: `Dodaj łącznik (-), jeśli znajduje się on w Twoim numerze kontaktowym.`,
      contractNumLabel: "Numer umowy",
      contractNumTooltip: 'Numer umowy znajdziesz w obszarze Rozliczenia i zamówienia na swoim <a target="_blank" href="https://manage.autodesk.com">koncie</a>.',
      currentCmEmailLabel: "Adres e-mail obecnego kierownika ds. umów",
      newCmEmailLabel: "Adres e-mail nowego kierownika ds. umów",
      newCmNameLabel: "Imię i nazwisko nowego kierownika ds. umów",
      newCmPhoneLabel: "Numer telefonu nowego kierownika ds. umów",
      pageTitle2: "3. Nowe informacje",
      pageTitle: "2. Obecne informacje",
      phoneNumPlaceholder: "Numer wraz z numerem kierunkowym"
    },
    authorizationRequestScreen: {
      option1: "Oświadczam, że jestem kierownikiem ds. umów lub firma będąca właścicielem subskrypcji upoważniła mnie do przesłania tego zgłoszenia.",
      confirmLabel: "Potwierdź, że masz uprawnienia przesłania tego zgłoszenia",
      pageTitle: "4. Upoważnienie do przesłania zgłoszenia"
    },
    successScreen: {
      cmWillReceiveEmail: `Nowy kierownik ds. umów otrzyma e-mail z dodatkowymi instrukcjami.`,
      emailWillBeSent: "Wkrótce otrzymasz potwierdzenie e-mail na adres: <email>",
      responseText4: `Umowę o numerze <contract-number> obsługuje nowy kierownik ds. umów:`
    },
    errors: {
      contractNumNotFound: "Nie znaleziono numeru umowy",
      emailNotAssociatedWithcontractNum: "Ten adres e-mail nie jest powiązany z powyższym numerem umowy.",
      enterContractNum: "Wprowadź swój numer umowy"
    },
    requestFailedScreen: {
      autoRenewSubs: "Z naszych danych wynika, że posiadasz subskrypcję z automatycznym odnawianiem. Aby zmienić kierownika ds. umów, konieczne będzie anulowanie subskrypcji i rozpoczęcie nowej.",
      autoRenewSubsTitle: "Odn&oacute;w subskrypcję automatycznie",
      inactiveContract: "Nie można przetworzyć zgłoszenia, ponieważ umowa nie jest już aktywna.",
      inactiveContractTitle: "Nieaktywna umowa"
    }
  },
  sc: {
    welcome: {
      clickGetStarted: "Kliknij przycisk Rozpocznij, aby zmienić koordynatora ds. oprogramowania.",
      modalTitle: "Zmień koordynatora ds. oprogramowania",
      noteBullet1: "W ten sposób można zmienić koordynatora ds. oprogramowania zajmującego się planami obsługi i subskrypcjami (z wyjątkiem produktów edukacyjnych)."
    },
    processInfoScreen: {
      currentScEmailLabel: "Adres e-mail bieżącego koordynatora ds. oprogramowania",
      newScEmailLabel: "Adres e-mail nowego koordynatora ds. oprogramowania",
      newScNameLabel: "Imię i nazwisko nowego koordynatora ds. oprogramowania",
      newScPhoneLabel: "Numer telefonu nowego koordynatora ds. oprogramowania",
      scEmailPlaceholder: "Powiązany z numerem seryjnym",
      importantInformation: "Ważne informacje"
    },
    authorizationRequestScreen: {
      option1: "Oświadczam, że jestem kierownikiem ds. umów, koordynatorem ds. oprogramowania lub firma będąca właścicielem subskrypcji upoważniła mnie do przesłania tego zgłoszenia."
    },
    successScreen: {
      responseText4: `Numer seryjny <serial-number> obsługuje nowy koordynator ds. oprogramowania:`,
      scWillReceiveEmail: `Nowy koordynator ds. oprogramowania otrzyma e-mail z dodatkowymi instrukcjami.`
    },
    errors: {
      emailNotAssociatedWithSerialNum: "Ten adres e-mail nie jest powiązany z powyższym numerem seryjnym.",
      tokenFlexSerialNumber: `You've entered a TokenFlex serial number. To change the Software Coordinator, please email your Autodesk Premier Expert at <strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>.`
    },
    requestFailedScreen: {
      serialNumberIneligle: "Nie można ukończyć przetwarzania wniosku, ponieważ dany numer seryjny nie uprawnia do zmiany koordynatora ds. oprogramowania.",
      serialNumberIneligleTitle: "Numer seryjny nie zapewnia odpowiednich uprawnień"
    }
  },
  ccna: {
    welcome: {
      clickGetStarted: "Kliknij przycisk Rozpocznij, aby zmienić dane kontaktowe firmy.",
      modalTitle: "Zmień nazwę lub adres firmy",
      noteBullet1: "Nazwę i adres firmy może zmienić <strong>tylko kierownik ds. umów.</strong>",
      noteBullet2: '<strong>Ten proces nie spowoduje przekazania prawa własności.</strong> Aby przenieść licencję na nowego właściciela, należy <a target="_blank" href="https://knowledge.autodesk.com/pl/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">wypełnić wniosek o przeniesienie licencji</a>.'
    },
    processInfoScreen: {
      reviewInfoTitle: "Sprawdź informacje dotyczące swojego konta",
      currentInfoTitle: "Obecne informacje",
      current: "Aktualnie: ",
      pageTitle2: "Wprowadź nowe informacje",
      pageTitleValidateAddr: "Sprawdź poprawność adresu",
      pageTitleConfirmChanges: "Potwierdź zmiany",
      changeInfoLabel: "Jakie informacje chcesz zmienić?",
      addressOption: "Adres",
      nameOption: "Nazwę firmy",
      nameAndAddressOption: "Zarówno nazwę, jak i adres firmy",
      newTaxIdLabel: "Czy masz również nowy numer identyfikacji podatkowej lub EIN",
      msgTOLS: 'Zgodnie z powyższymi odpowiedziami musisz <a target="_blank" href="https://knowledge.autodesk.com/pl/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses"> wypełnić wniosek o przeniesienie licencji,</a> aby przekazać licencję nowemu właścicielowi. Jeśli potrzebujesz pomocy, <Strong>skontaktuj się z obsługą klienta, korzystając z poniższych danych</Strong>',
      unauthorizedUser: "Nie masz uprawnień do wprowadzania zmian dotyczących tej umowy.",
      msgAutoRenew: 'Zmian nazw lub adresów firm korzystających z automatycznych odnowień i rozliczeń cyklicznych, a także zmian dotyczących niektórych umów w sprawie oprogramowania chmurowego nie można zgłaszać przez Internet. Aby <a target="_blank" href="https://knowledge.autodesk.com/pl/customer-service/account-management/account-profile/change-company-name-and-address">zmienić nazwę lub adres firmy</a>, wykonaj poniższe czynności.',
      msgExpiredContract: "Ta umowa wygasła.",
      notEligible: "Ta umowa nie kwalifikuje się.",
      changingInfoFor: "Zmiana informacji dotyczących umowy o numerze: <contract-number>",
      companyName: "Nazwa firmy",
      accountCSN: `koncie CSN`,
      streetAddress: "Ulica",
      city: "Miejscowość",
      state: "Województwo",
      postalCode: "Kod pocztowy",
      country: "Kraj",
      validateAddDisclaimer: "Najlepiej dopasowany adres zaznaczono poniżej. Wybranie wprowadzonego może wydłużyć czas przetwarzania.",
      confirmDisclaimer: "Przed przesłaniem sprawdź, czy wprowadzone zmiany nie zawierają błędów. Możesz wrócić do poprzedniego ekranu, aby wprowadzić niezbędne poprawki.",
      recommendedAddr: "Najlepiej dopasowany adres",
      enteredAddr: "Wprowadzono adres",
      changeWillbeAppliedFor: "Zmiany zostaną zastosowane do umowy o numerze: <contract-number>",
      new: "NOWY",
      old: "STARY",
      emailWillBeSent: "Potwierdzenie e-mail zostanie dostarczone na adres: <email>"
    },
    successScreen: {
      emailWillBeSent: "Potwierdzenie e-mail zostanie dostarczone na adres: <email>",
      changeAppliedFor: "Numer umowy <contract-number> został zaktualizowany, obecnie jest to:",
      nonCleansedAddrMsg: "Wkrótce otrzymasz e-mail z potwierdzeniem i numerem zgłoszenia. Zachowaj ten e-mail.<br><br><strong>Na zgłoszenie odpowiemy w ciągu dwóch dni roboczych.</strong><br><br>Jeśli nie otrzymasz e-maila z potwierdzeniem w ciągu godziny, sprawdź folder ze spamem lub skontaktuj się z administratorem sieci w celu uzyskania pomocy."
    },
    errors: {
      contractNumNotFound: "Nie znaleziono numeru umowy",
      invalidContractNum: "Nieprawidłowy numer umowy",
      enterContractNum: "Wprowadź numer umowy"
    }
  }
};